// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"d85806c1","380":"1d3319eb","988":"91f9ec2d"}[chunkId] + ".chunk.js";
};